import { Skeleton } from "@mui/material";
var SkeletonLoader = function (props) {
    var _a = props.type, type = _a === void 0 ? "rounded" : _a;
    return (
    /*#__PURE__*/
    // <MuiStack direction={'column'} spacing={1} padding={1} style={{ width: '100vw', height: '60vh' }}>
    React.createElement(Skeleton, {
        variant: type,
        animation: "wave",
        width: "100%",
        height: '100%',
        sx: {
            bgcolor: '#f5f5f0'
        }
    })
    // </MuiStack>
    );
};
export default SkeletonLoader;
